import {FC} from 'react'
import {InputDate} from '../../InputV2'
type Props = {
  name: string
  disabled?: boolean
  readOnly?: boolean
  required?: boolean
  labelText?: string
  minValue?: string
  maxValue?: string
  onChange?: (e: any) => void
}
const InputDateWrapper: FC<Props> = ({
  name,
  disabled,
  readOnly,
  required,
  labelText,
  minValue,
  maxValue,
  onChange,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <InputDate
        name={name}
        disabled={disabled}
        minValue={minValue}
        maxValue={maxValue}
        readOnly={readOnly}
        onChange={onChange}
      />
    </div>
  )
}

export default InputDateWrapper
